import { ChartType } from '@dbl/core/chart';

import type {
  IAnalysisPercentStackBarChartResponseDto,
  IAnalysisPercentStackBarChartResultVo,
} from '../types';

import {
  normalizeTableDataList,
  pickAxisChartWireVo,
  pickChartDisplayMeta,
} from './common';

export function transformPercentStackBarChartResponseDtoToVo(
  dto: IAnalysisPercentStackBarChartResponseDto,
): IAnalysisPercentStackBarChartResultVo {
  const {
    percent_stack_bar_chart: percentStackBarChartWire,
    table_data: tableDataWire,
  } = dto;
  const { chartData: percentStackBarData, isNoData } = pickAxisChartWireVo(
    percentStackBarChartWire,
  );

  return {
    ...pickChartDisplayMeta(dto),
    chartType: ChartType.PercentStackBar,
    isNoData,
    ...(isNoData
      ? {}
      : {
          percentStackBarData,
          tableData: normalizeTableDataList(tableDataWire),
        }),
  };
}
